import React from 'react';
import T from 'prop-types';
import cx from 'classnames';

import { pagesList } from '../configs';

const PageNav = ({
  active,
  onChange,
}) => {
  const hasAvailableNav = pagesList.some(item => item.allowed);

  if (!hasAvailableNav) return null;

  return (
    <nav className="reports-and-exports-page__nav">
      {pagesList.filter(item => !item.hidden).map(({ value, name }) => {
        const isActive = value === active;

        return (
          <a
            key={value}
            className={cx('reports-and-exports-page__nav-item', isActive && 'active')}
            data-title={name}
            onClick={(e) => {
              e.preventDefault();
              !isActive && onChange(value);
            }}
          >
            {name}
          </a>
        );
      })}
    </nav>
  );
};

PageNav.propTypes = {
  active: T.string.isRequired,
  onChange: T.func.isRequired,
};

export default PageNav;
